var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "y": "0.5",
      "width": "24",
      "height": "24",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.5984 8.30078L9.89844 16.0008L6.39844 12.5008",
      "stroke": "#07B53B",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }